import manager from '@mailobj-browser/front/js/contracts/manager.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import readyStateChange from '@mailobj-browser/front/js/events/types/readyStateChange.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const readyStates  = ['interactive', 'complete']
const resolvers = new WeakMap()

const onReadyStateChange = object(listener, {
  type: readyStateChange,
  passive,
  task (
    document
  ) {
    const { readyState } = document
    const resolve = resolvers.get(document)

    if (resolve && readyStates.includes(readyState)) {
      this.forget(document)
      resolvers.delete(document)
	    //console.time('contracts')
      resolve()
    }
  }
})

export default async (window, contract) => {
  const { document } = window
  const [promise, { resolve }] = resolvable()

  resolvers.set(document, resolve)
  onReadyStateChange.listen(document)
  onReadyStateChange.task(document)
  await promise
  await manager.register(window, contract)
  await globalThis.thenable?.resolve(manager)
  //console.timeEnd('contracts')
  //console.timeEnd('tti')
}
